import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {PrivilegeService} from "../service/privilege.service";

@Injectable()
export class RolesGuard {

  constructor(
    private router: Router,
    private privilegeService: PrivilegeService,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const allowedRoutes: string[] = route.data['allowedRoutes'];

    const currentRole = this.privilegeService._role.value;

    if (!allowedRoutes.includes(currentRole)) {
      return this.router.parseUrl('/proibido');
    }
    return true;
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(route, state);
  }

}
